import { timeFormat, timeParse } from "d3-time-format";
import { DATE_FORMAT, FREQ_FORMATS, FREQUENCIES } from "$utils/consts.js";

/** @typedef {import("./consts.js").Frequency} Frequency */

/**
 * Parse a date string into a Date object based on the given format.
 * @param {string} dateString - The date string to parse.
 * @param {Frequency} format - The format of the date string.
 * @returns {Date|null} - The parsed Date object, or null if parsing fails.
 */
export function parseDate(dateString, format = FREQUENCIES.DAILY) {
  return timeParse(FREQ_FORMATS[format] || DATE_FORMAT)(dateString);
}

/**
 * Format a Date object into a string based on the given format.
 * @param {Date} date - The Date object to format.
 * @param {Frequency} format - The desired output format.
 * @returns {string} - The formatted date string.
 */
export function formatDate(date, format = FREQUENCIES.DAILY) {
  return timeFormat(FREQ_FORMATS[format] || DATE_FORMAT)(date);
}

export function roundDate(date, format = FREQUENCIES.DAILY) {
  if (!date) return null;
  let formatted = formatDate(date, format);
  return parseDate(formatted, format);
}
